<template>
    <div :class="classes">
        <el-input-number  v-model="crrentValue" :controls-position="controlsPosition" @change="handleChange" @blur="blur"
        :min="min" :max="max" :step="step" :precision="precision" :controls="controls" :placeholde="placeholder" :disabled="disabled"></el-input-number>
    </div>
</template>
<script>
const prefixCls = 'wt-input-number'
export default {
  name: 'wt-input-number',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    controlsPosition: {
      type: String,
      default: ''
    },
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: Number,
      default: Infinity
    },
    step: {
      type: Number,
      default: 1
    },
    precision: {
      type: Number,
      default: 0
    },
    controls: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      crrentValue: this.value
    }
  },
  watch: {
    value (val) {
      this.crrentValue = val
    },
    crrentValue (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    handleChange (val) {
      this.$emit('change', this.crrentValue)
    },
    blur (e) {
      this.$emit('blur', this.crrentValue)
    }
  }

}
</script>
<style lang="less">

</style>
